import React, { useState } from 'react';
import style from './login.module.css'
import { AiOutlineClose } from 'react-icons/ai'
function Login({ setShowLogin,setShowSignup,LoginUser }) {

    const [email, setEmail] = useState(false)
    const [password, setPassword] = useState(false)

    return <div className={style.display}>
        <div className={style.Login} >
            <div className='p-8 flex flex-col gap-8'>
                <div className='flex justify-between items-center'>
                    <AiOutlineClose className='text-[1A3168] text-lg' onClick={()=>{setShowLogin(false)}} />
                    <button className='text-[#1A3168] text-lg'
                         onClick={()=>{
                             setShowLogin(false)
                             setShowSignup(true)
                            }} 
                    >create account</button>
                </div>
                <div className='flex flex-col justify-between items-start gap-[4vh]'>
                    <p className='text-[#1A3168] text-xl font-semibold '>Login</p>
                    <div className='flex flex-col gap-4'>
                        <input className='text-[#1A3168] bg-[#5CC9FF59] w-[20vw] p-2 rounded-[0.8vw]' placeholder='username' 
                            onChange={(e)=>{setEmail(e.target.value)}}/>
                        <input className='text-[#1A3168] bg-[#5CC9FF59] w-[20vw] p-2 rounded-[0.8vw]' placeholder='password' 
                            onChange={(e)=>{setPassword(e.target.value)}}/>
                    </div>
                    <div className='flex flex-col gap-2'>
                        <button className='bg-[#1A3168] text-[#FFF856] p-2 rounded-lg w-20'
                            onClick={(e)=>{LoginUser(email,password,e);}}>
                            Login
                        </button>
                        <p className='text-[#1A3168]'>
                            forgot password?
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div >;
}

export default Login;
